// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608211823/js/" + chunkId + "." + {"44":"34674ff8","225":"a9db6e23","481":"3c93bc7e","486":"204800ff","770":"f085526c"}[chunkId] + ".0.9081344839103914.chunk.js";
};